import { useHttp } from "../http/useHttp";
import { useAxiosMutation } from "../http/useAxiosMutation";
import { useAuth } from "../auth/useAuth";
import { paths } from "../generated-types";

type LoginOperation = paths["/dashboard/login"]["post"];
export type ILoginInput = LoginOperation["requestBody"]["content"]["application/json"];
type UseLoginResponse = LoginOperation["responses"][200]["content"]["application/json"];

export const useLogin = () => {
  const { refetch } = useAuth();
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMutation<
    UseLoginResponse,
    ILoginInput
  >({
    mutationKey: ["login"],
    mutationFn: (input) => client.post("/login", input),
    onSuccess: () => refetch(),
  });

  return { login: mutate, isPending, status, data, error };
};
